export default __webpack_public_path__ + "static/media/PRIMARY-COLORS.caadd9a0.png";